import { ToggleProps } from './toggle.props';
import { CSSTransition } from 'react-transition-group';
import React, { useState } from 'react';
import { IconDropsScienceMolecule } from '../icon-drops-science';
import { useToggleStyles } from '../../../styles/molecules/toggle.styles';

export const ToggleMolecule = (props: ToggleProps) => {
  const [sightSaverOpenned, openSightSaver] = useState(false);
  const classes = useToggleStyles();

  function toggleSightSaver() {
    openSightSaver(!sightSaverOpenned);
  }

  return (
    <div
      data-cy="data-toggle-molecule"
      className={`w-full  border-white border-t-2 border-b-2 py-2.5 mt-1 lg:mt-8 border-opacity-30 ${props.display}  relative z-20`}
    >
      <div className="text-white flex flex-row w-full">
        <div className="w-full block text-base" onClick={toggleSightSaver}>
          {props.title}
        </div>
        <div
          className="w-2/25 block cursor-pointer text-2xl "
          onClick={toggleSightSaver}
        >
          {sightSaverOpenned ? '-' : '+'}
        </div>
      </div>

      <CSSTransition
        mountOnEnter
        unmountOnExit
        timeout={250}
        in={sightSaverOpenned}
        classNames={'article-transition'}
      >
        <div className={`w-full pb-10 ${classes['article-transition']}`}>
          <IconDropsScienceMolecule />
        </div>
      </CSSTransition>
    </div>
  );
};
